import React from 'react';
import PropTypes from 'prop-types';
import Star from 'assets/icons/Star';
import GirdedCross from 'assets/icons/GirdedCross';

import { NOTIFICATION_TYPES } from 'utils/constants/notifications';
import { Icon } from '@ontruck/orc';

export const CloseButton = ({ closeToast }) => {
  return (
    <div className="Toastify__close-button" onClick={closeToast}>
      ✕
    </div>
  );
};

const Notification = ({
  className,
  title,
  content,
  handleClick,
  type,
  inLineLinkText,
  inlineLinkHandle,
}) => {
  const renderIcon = () => {
    switch (type) {
      case NOTIFICATION_TYPES.INFO:
        return (
          <div
            className="notification__icon-container notification__icon-container--info"
            data-testid="notification__icon--info"
          >
            <Star />
          </div>
        );
      case NOTIFICATION_TYPES.SUCCESS:
        return (
          <div
            className="notification__icon-container notification__icon-container--success"
            data-testid="notification__icon--success"
          >
            <Icon glyph="success" size="1.6rem" />
          </div>
        );
      case NOTIFICATION_TYPES.WARNING:
        return (
          <div
            className="notification__icon-container notification__icon-container--warning"
            data-testid="notification__icon--warning"
          >
            <Icon glyph="girded-exclamation" size="1.6rem" />
          </div>
        );
      case NOTIFICATION_TYPES.ERROR:
        return (
          <div
            className="notification__icon-container notification__icon-container--error"
            data-testid="notification__icon--error"
          >
            <GirdedCross />
          </div>
        );
      case NOTIFICATION_TYPES.DEFAULT:
      default:
        return (
          <div
            className="notification__icon-container notification__icon-container--default"
            data-testid="notification__icon--default"
          >
            <Icon glyph="girded-exclamation" size="1.6rem" />
          </div>
        );
    }
  };

  return (
    <div className={className} data-testid="notification" onClick={handleClick}>
      <div className="notification">
        {renderIcon()}
        <div className="notification__body">
          <div className="notification__title">{title}</div>
          <div className="notification__content">
            <span className="notification__text">
              {content}
              {inLineLinkText && inlineLinkHandle && (
                <button
                  className="notification__link"
                  onClick={inlineLinkHandle}
                  data-testid="notification__inline-button"
                >
                  {inLineLinkText}
                </button>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

Notification.defaultProps = {
  content: '',
  inLineLinkText: '',
  inlineLinkHandle: null,
  handleClick: () => {
    /*noop*/
  },
};

Notification.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  handleClick: PropTypes.func,
  inLineLinkText: PropTypes.string,
  inlineLinkHandle: PropTypes.func,
};

export default Notification;
